import * as angular from "angular";
import {$bringozFactory} from "../persistence-layer/bringoz-factory.factory";
import {BringozApi} from "../persistence-layer/models/bringoz-api.model";
import {DataStoreConfig} from "../persistence-layer/models/datastore-config.model";
import {PushNotificationsConfig} from "../persistence-layer/models/push-notifications-config.model";

angular
  .module('bringoz.admin.customers')
  .factory('$customers', customersObjectFactory);

/* @ngInject */
function customersObjectFactory($bringozFactory: $bringozFactory,
                                customersAPI: BringozApi,
                                Customers_DS: DataStoreConfig,
                                Customers_PN: PushNotificationsConfig) {

  function $customers(id: string) {
    return $bringozFactory(id, customersAPI, Customers_DS, Customers_PN);
  }

  return $customers;
}
